/*global VeloxViewController*/

var newsListController = new VeloxViewController({
        directory: "views/news",
        name: "newsList",
        route: "news",
    }
);

newsListController.prepareDataOnEnter =  function(data, callback){
    this.api.api.multiread({
        news: { search : {n_lang: VeloxWebView.i18n.getLang(), n_published: true}, orderBy: "n_date desc"},
    }, function(err, reads){
        if(err){ return callback(err) ; }
        reads.news.forEach(function(news){
            news.str_date = moment(news.n_date).format("L") ;
        })
        callback(null, { news : reads.news }) ;
    }.bind(this)) ;
} ;


module.exports = newsListController ;